
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-demo/guild-war-pvp",
      function () {
        return require("private-next-pages/battle-demo/guild-war-pvp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-demo/guild-war-pvp"])
      });
    }
  